import { Helmet } from "react-helmet-async"
import { TripsList } from "../../../../Trips"
import { useParams } from "../../../../router-utils"

export default function TripSourceDetailsPage() {
	const { tripSourceId } = useParams(
		"/trip-sources/:tripSourceId/payments/incoming"
	)
	return (
		<>
			<Helmet>
				<title>B2B Source Trips</title>
			</Helmet>
			<TripsList
				hideBulkActions
				hideTripSourceFilter
				hideTouristProfileFilter
				tripSourceIds={tripSourceId}
			/>
		</>
	)
}
